var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubscribed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.15001 16.6667C6.15333 16.6667 6.96668 15.8533 6.96668 14.85C6.96668 13.8467 6.15333 13.0333 5.15001 13.0333C4.14669 13.0333 3.33334 13.8467 3.33334 14.85C3.33334 15.8533 4.14669 16.6667 5.15001 16.6667Z",
    fill: "url(#paint0_linear_6098_19649)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.65834 8.525C3.95834 8.40833 3.33334 8.98333 3.33334 9.69167C3.33334 10.2833 3.77501 10.7583 4.35834 10.8583C6.79168 11.2833 8.70834 13.2083 9.14168 15.6417C9.24168 16.225 9.71668 16.6667 10.3083 16.6667C11.0167 16.6667 11.5917 16.0417 11.4833 15.3417C10.9167 11.8417 8.15834 9.08333 4.65834 8.525V8.525ZM4.63334 3.76667C3.94168 3.69167 3.33334 4.25 3.33334 4.94167C3.33334 5.55 3.79168 6.05 4.39168 6.10833C9.40001 6.60833 13.3833 10.5917 13.8833 15.6C13.9417 16.2083 14.4417 16.6667 15.05 16.6667C15.75 16.6667 16.3 16.0583 16.2333 15.3667C15.625 9.25 10.7583 4.375 4.63334 3.76667V3.76667Z",
    fill: "url(#paint1_linear_6098_19649)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6098_19649",
    x1: 5.15001,
    y1: 13.0333,
    x2: 5.15001,
    y2: 16.6667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B73E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#435ED5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6098_19649",
    x1: 9.78608,
    y1: 3.7599,
    x2: 9.78608,
    y2: 16.6667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B73E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#435ED5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscribed);
export default __webpack_public_path__ + "static/media/subscribed.3e41bae2148c0b1e89dc39b27039d7b3.svg";
export { ForwardRef as ReactComponent };